import { useMemo } from 'react';

import qs from 'qs';
import { useLocation } from 'react-router';

import { SEARCH_QUERY_KEYS } from 'src/app/pages/search/shared/types';

type Result = ModelHookResult<{
	showLandingPage: boolean;
}>;

export function useLandingPage(): Result {
	const location = useLocation();

	const hasQuery = useMemo(() => {
		const query = qs.parse(location.search, { ignoreQueryPrefix: true });
		return Object.keys(query).some((key) => SEARCH_QUERY_KEYS.includes(key));
	}, [location]);

	return {
		data: {
			showLandingPage: !hasQuery,
		},
	};
}
